<!--<ng-container *ngIf="!documentId">-->

<!--  &lt;!&ndash;  <iframe&ndash;&gt;-->
<!--  &lt;!&ndash;    *ngIf="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;    [src]="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;    [class]="class"&ndash;&gt;-->
<!--  &lt;!&ndash;    [width]="width"&ndash;&gt;-->
<!--  &lt;!&ndash;    [height]="height"></iframe>&ndash;&gt;-->
<!--  &lt;!&ndash;  <object *ngIf="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;          style="width: 100%; height:100%;object-fit: contain;"&ndash;&gt;-->
<!--  &lt;!&ndash;          [data]="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;          type="application/pdf">&ndash;&gt;-->
<!--  &lt;!&ndash;  </object>&ndash;&gt;-->


<!--  <div class="lg:block md:block hidden w-full h-full">-->
<!--    <object *ngIf="pdfSrc"-->
<!--            style="object-fit: contain"-->
<!--            [data]="pdfSrc"-->
<!--            [class]="class"-->
<!--            [width]="width"-->
<!--            [height]="height"-->
<!--            type="image/jpeg">-->
<!--    </object>-->
<!--  </div>-->

<!--  <p class="lg:hidden md:hidden block pt-8 px-3 text-center">Your browser does not support viewing PDFs.-->
<!--    <br>-->
<!--    <a class="pt-3" [href]="pdfSrc" target="_blank" rel="noopener noreferrer">Click here to open in new window</a>-->
<!--  </p>-->

<!--</ng-container>-->

<!--<ng-container *ngIf="documentId">-->

<!--  &lt;!&ndash;  <object *ngIf="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;          style="object-fit: contain"&ndash;&gt;-->
<!--  &lt;!&ndash;          [data]="pdfSrc"&ndash;&gt;-->
<!--  &lt;!&ndash;          [class]="class"&ndash;&gt;-->
<!--  &lt;!&ndash;          [width]="width"&ndash;&gt;-->
<!--  &lt;!&ndash;          [height]="height"&ndash;&gt;-->
<!--  &lt;!&ndash;          type="application/pdf">&ndash;&gt;-->
<!--  &lt;!&ndash;  </object>&ndash;&gt;-->


<!--  <div class="lg:block md:block hidden w-full h-full">-->
<!--    <object *ngIf="pdfSrc"-->
<!--            style="width: 100%; height:100%;object-fit: contain;"-->
<!--            [data]="pdfSrc"-->
<!--            [class]="class"-->
<!--            [width]="width"-->
<!--            [height]="height"-->
<!--            type="image/jpeg">-->
<!--    </object>-->
<!--  </div>-->

<!--  <p class="lg:hidden md:hidden block pt-8 px-3 text-center">Your browser does not support viewing PDFs.-->
<!--    <br>-->
<!--    <a class="pt-3" [href]="pdfSrc" target="_blank" rel="noopener noreferrer">Click here to open in new window</a>-->
<!--  </p>-->

<!--</ng-container>-->

<!-- Only used to open in new tab -->


<p-progressSpinner *ngIf="!pdfSrc" class="flex w-5rem h-5rem m-auto pt-8"></p-progressSpinner>

  <a #pdfLink
     class="hidden"
     [href]="pdfSrc"
     target="_blank"
     rel="noopener noreferrer">
    Open PDF
  </a>

  <ng-container *ngIf="!documentId">
    <!--  <iframe-->
    <!--    *ngIf="pdfSrc"-->
    <!--    [src]="pdfSrc"-->
    <!--    [class]="class"-->
    <!--    [width]="width"-->
    <!--    [height]="height"></iframe>-->

    <object *ngIf="pdfSrc"
            [data]="pdfSrc"
            [class]="class"
            [width]="width"
            [height]="height"
            type="image/jpeg" style="object-fit: scale-down">
    </object>

  </ng-container>

  <ng-container *ngIf="documentId">
    <object *ngIf="pdfSrc"
            [data]="pdfSrc"
            [class]="class"
            [width]="width"
            [height]="height"
            type="image/jpeg" style="object-fit: scale-down">
    </object>


  </ng-container>
